// mds-dojo — dojo/mouse: enter/leave extension events + button helpers.
// mouse.enter/leave map to the native mouseenter/mouseleave (what dojo emulated).

type Handle = { remove: () => void };

function extension(domEvent: string): any {
  return (node: any, listener: (e: Event) => void): Handle => {
    node.addEventListener(domEvent, listener);
    return { remove: () => node.removeEventListener(domEvent, listener) };
  };
}

const mouse = {
  enter: extension('mouseenter'),
  leave: extension('mouseleave'),
  wheel: extension('wheel'),
  isLeft: (e: MouseEvent) => e.button === 0,
  isMiddle: (e: MouseEvent) => e.button === 1,
  isRight: (e: MouseEvent) => e.button === 2,
};

export default mouse;
